export default __webpack_public_path__ + "static/media/donkey.2e51fbf6.png";